"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Musk = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const DrawCards_1 = require("../../deferredActions/DrawCards");
const SelectAmount_1 = require("../../inputs/SelectAmount");
const Resources_1 = require("../../Resources");
const SelectCard_1 = require("../../inputs/SelectCard");
const LogHelper_1 = require("../../LogHelper");
class Musk extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.MUSK,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L28',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().minus().cards(1).secondaryTag(Tags_1.Tags.EARTH).colon().cards(1).secondaryTag(Tags_1.Tags.SPACE).titanium(1).asterix();
                    b.br;
                    b.titanium(6);
                    b.br.br;
                }),
                description: 'Once per game, discard any number of Earth cards to draw/gain that many Space cards and titanium. Gain 6 titanium.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const eligibleCards = player.cardsInHand.filter((card) => card.tags.includes(Tags_1.Tags.EARTH));
        const max = eligibleCards.length;
        return new SelectAmount_1.SelectAmount('Select number of Earth cards to discard', 'Discard cards', (amount) => {
            const discardEarthCards = new DeferredAction_1.DeferredAction(player, () => {
                if (amount === 0)
                    return undefined;
                return new SelectCard_1.SelectCard(`Select ${amount} Earth card(s) to discard`, 'Discard', eligibleCards, (foundCards) => {
                    for (const card of foundCards) {
                        player.cardsInHand.splice(player.cardsInHand.indexOf(card), 1);
                        player.game.dealer.discard(card);
                    }
                    LogHelper_1.LogHelper.logPlayerDiscardedCards(player, foundCards);
                    return undefined;
                }, { min: amount, max: amount });
            });
            player.game.defer(discardEarthCards, DeferredAction_1.Priority.DISCARD_BEFORE_DRAW);
            player.game.defer(DrawCards_1.DrawCards.keepAll(player, amount, { tag: Tags_1.Tags.SPACE }));
            player.addResource(Resources_1.Resources.TITANIUM, 6 + amount);
            this.isDisabled = true;
            return undefined;
        }, 0, max);
    }
}
exports.Musk = Musk;
//# sourceMappingURL=Musk.js.map